import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

// Copies the source input's value and confirms with a brief tooltip on the clicked button.
export default class extends Controller {
  static targets = ["source"];

  copy(event) {
    // currentTarget is gone once the event has dispatched, before the clipboard promise settles.
    const button = event.currentTarget;
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      const tooltip = button._tippy || tippy(button, {
        trigger: "manual",
        onShow(instance) { setTimeout(() => instance.hide(), 1500); },
      });
      tooltip.setContent("Copied!");
      tooltip.show();
    }, () => this.sourceTarget.select());
  }
}
